export enum dataExtractTabIds {
  EXTRACT_DATA = 'extract-data',
  VIEW_STATUS = 'view-status'
}
